import { valuesWithAppName } from "@/lib/i18n";

export const getFAQContentParams = (t: any) => {
  return valuesWithAppName(t, {
    br: (_) => <br />,
    strong: (children) => <strong>{children}</strong>,
    ol: (children) => <ol>{children}</ol>,
    ul: (children) => <ul>{children}</ul>,
    li: (children) => <li>{children}</li>,
  });
};

export const getFAQUnformattedContentParams = (t: any) => {
  return valuesWithAppName(t, {
    br: (_) => "\n",
    strong: (children) => children,
    ol: (children) => children,
    ul: (children) => children,
    li: (children) => `${children}\n`,
    a: (children) => children,
  });
};
